// context/DraftContext.jsx
import React, { createContext, useContext, useState } from "react";

const DraftContext = createContext(null);

export function DraftProvider({ children }) {
  const [savedContent, setSavedContent] = useState([]);

  const saveDraft = (draft) => {
    setSavedContent(prev => [
      {
        id: crypto.randomUUID(),
        createdAt: Date.now(),
        status: "saved",
        ...draft
      },
      ...prev
    ]);
  };

  const removeDraft = (id) => {
    setSavedContent(prev => prev.filter(item => item.id !== id));
  };

  const clearAllDrafts = () => {
    setSavedContent([]);
  };

  return (
    <DraftContext.Provider value={{ 
      savedContent, 
      saveDraft, 
      removeDraft,
      clearAllDrafts 
    }}>
      {children}
    </DraftContext.Provider>
  );
}

export function useDrafts() {
  const ctx = useContext(DraftContext);
  if (!ctx) throw new Error("useDrafts must be used inside DraftProvider");
  return ctx;
}